import React, { useState } from "react";
// If you use Lucide icons, they add a great modern touch
import { Calendar, User, BarChart3, ChevronDown } from "lucide-react";

const CRMStageReport = () => {
  const reportData = [
    {
      salesman: "Ahmed",
      leadNo: "LD-0012",
      customer: "ABC Trading LLC",
      quotationNo: "QT-0345",
      salesOrderNo: "SO-0098",
      stage: "Won",
      value: 110000,
      date: "2025-01-15",
    },
    {
      salesman: "Ahmed",
      leadNo: "LD-0015",
      customer: "Gulf Tech",
      quotationNo: "QT-0350",
      salesOrderNo: "-",
      stage: "Quotation",
      value: 95000,
      date: "2025-01-20",
    },
    {
      salesman: "Rahul",
      leadNo: "LD-0021",
      customer: "Star LLC",
      quotationNo: "QT-0351",
      salesOrderNo: "SO-0102",
      stage: "Won",
      value: 75000,
      date: "2025-02-10",
    },
    {
      salesman: "Rahul",
      leadNo: "LD-0024",
      customer: "Metro Corp",
      quotationNo: "-",
      salesOrderNo: "-",
      stage: "Lead",
      value: 60000,
      date: "2025-02-14",
    },
    {
      salesman: "Sana",
      leadNo: "LD-0030",
      customer: "Bright Corp",
      quotationNo: "QT-0360",
      salesOrderNo: "-",
      stage: "Proposal",
      value: 62000,
      date: "2025-03-05",
    },
    {
      salesman: "Sana",
      leadNo: "LD-0032",
      customer: "Future Systems",
      quotationNo: "QT-0365",
      salesOrderNo: "SO-0108",
      stage: "Won",
      value: 88000,
      date: "2025-03-12",
    },
  ];

  const [filter, setFilter] = useState({
    salesman: "All",
    stage: "All",
    startDate: "2025-01-01",
    endDate: "2025-03-31",
  });

  const filteredData = reportData.filter((item) => {
    const salesmanMatch =
      filter.salesman === "All" || item.salesman === filter.salesman;
    const stageMatch = filter.stage === "All" || item.stage === filter.stage;
    const dateMatch =
      item.date >= filter.startDate && item.date <= filter.endDate;
    return salesmanMatch && stageMatch && dateMatch;
  });

  const totalValue = filteredData.reduce((acc, curr) => acc + curr.value, 0);

  const getStageColor = (stage) => {
    switch (stage) {
      case "Won":
        return "bg-emerald-50 text-emerald-700 border-emerald-100";
      case "Quotation":
        return "bg-blue-50 text-blue-700 border-blue-100";
      case "Proposal":
        return "bg-violet-50 text-violet-700 border-violet-100";
      case "Lead":
        return "bg-amber-50 text-amber-700 border-amber-100";
      default:
        return "bg-slate-50 text-slate-700 border-slate-100";
    }
  };

  return (
    <div className="p-4 bg-slate-50 ">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-4">
        <div>
          <h1 className="text-2xl font-semibold text-slate-900 tracking-tight">
            CRM Stage Report
          </h1>
          <p className="text-slate-500 text-sm">
            Track deal movement and conversion by salesman.
          </p>
        </div>
      </div>

      {/* Modern Filter Bar */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4 bg-white p-4 rounded-2xl shadow-sm border border-slate-200">
        {/* Salesman Filter */}
        <div className="relative">
          <label className="flex items-center gap-2 text-[11px] font-bold text-slate-400 uppercase mb-2 px-1">
            <User size={12} /> Salesperson
          </label>
          <select
            className="w-full appearance-none bg-slate-50 border border-slate-200 text-slate-700 text-sm rounded-xl px-4 py-2.5 outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all cursor-pointer"
            onChange={(e) => setFilter({ ...filter, salesman: e.target.value })}
          >
            <option value="All">All Personnel</option>
            <option value="Ahmed">Ahmed</option>
            <option value="Rahul">Rahul</option>
            <option value="Sana">Sana</option>
          </select>
          <ChevronDown
            size={16}
            className="absolute right-3 bottom-3 text-slate-400 pointer-events-none"
          />
        </div>

        {/* Stage Filter */}
        <div className="relative">
          <label className="flex items-center gap-2 text-[11px] font-bold text-slate-400 uppercase mb-2 px-1">
            <BarChart3 size={12} /> Stage
          </label>
          <select
            className="w-full appearance-none bg-slate-50 border border-slate-200 text-slate-700 text-sm rounded-xl px-4 py-2.5 outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all cursor-pointer"
            onChange={(e) => setFilter({ ...filter, stage: e.target.value })}
          >
            <option value="All">All Stages</option>
            <option value="Lead">Lead</option>
            <option value="Quotation">Quotation</option>
            <option value="Proposal">Proposal</option>
            <option value="Won">Won</option>
          </select>
          <ChevronDown
            size={16}
            className="absolute right-3 bottom-3 text-slate-400 pointer-events-none"
          />
        </div>

        {/* Date From */}
        <div>
          <label className="flex items-center gap-2 text-[11px] font-bold text-slate-400 uppercase mb-2 px-1">
            <Calendar size={12} /> Date From
          </label>
          <input
            type="date"
            value={filter.startDate}
            className="w-full bg-slate-50 border border-slate-200 text-slate-700 text-sm rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500/20 transition-all"
            onChange={(e) =>
              setFilter({ ...filter, startDate: e.target.value })
            }
          />
        </div>

        {/* Date To */}
        <div>
          <label className="flex items-center gap-2 text-[11px] font-bold text-slate-400 uppercase mb-2 px-1">
            <Calendar size={12} /> Date To
          </label>
          <input
            type="date"
            value={filter.endDate}
            className="w-full bg-slate-50 border border-slate-200 text-slate-700 text-sm rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500/20 transition-all"
            onChange={(e) => setFilter({ ...filter, endDate: e.target.value })}
          />
        </div>
      </div>

      {/* Table Section */}
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm border-collapse">
            <thead>
              <tr className="bg-slate-50/50 border-b border-slate-200">
                <th className="px-6 py-4 font-bold text-slate-500 uppercase text-[10px] tracking-widest">
                  Salesman
                </th>
                <th className="px-6 py-4 font-bold text-slate-500 uppercase text-[10px] tracking-widest">
                  Lead & Customer
                </th>
                <th className="px-6 py-4 font-bold text-slate-500 uppercase text-[10px] tracking-widest">
                  Quotation / SO
                </th>
                <th className="px-6 py-4 font-bold text-slate-500 uppercase text-[10px] tracking-widest">
                  Current Stage
                </th>
                <th className="px-6 py-4 font-bold text-slate-500 uppercase text-[10px] tracking-widest text-right">
                  Deal Value
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {filteredData.map((row, index) => (
                <tr
                  key={index}
                  className="hover:bg-blue-50/30 transition-colors group"
                >
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold text-xs">
                        {row.salesman.charAt(0)}
                      </div>
                      <span className="font-semibold text-slate-700">
                        {row.salesman}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-slate-900 font-medium">
                      {row.customer}
                    </div>
                    <div className="text-[11px] text-slate-400 font-mono">
                      {row.leadNo}
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-slate-600">{row.quotationNo}</div>
                    <div className="text-[11px] text-slate-400">
                      {row.salesOrderNo !== "-" ? (
                        row.salesOrderNo
                      ) : (
                        <span className="text-slate-300 italic">No SO</span>
                      )}
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`px-3 py-1 rounded-lg text-[10px] font-bold border uppercase tracking-wider ${getStageColor(row.stage)}`}
                    >
                      {row.stage}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right">
                    <span className="font-bold text-slate-800 text-base">
                      {row.value.toLocaleString()}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {filteredData.length === 0 && (
          <div className="py-20 flex flex-col items-center justify-center text-slate-400">
            <BarChart3 size={48} className="mb-4 opacity-20" />
            <p className="text-sm font-medium">
              No transactions found matching your criteria
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CRMStageReport;
